import { render, staticRenderFns } from "./NewPrescription.vue?vue&type=template&id=c86b3ae6&scoped=true&"
import script from "./NewPrescription.vue?vue&type=script&lang=js&"
export * from "./NewPrescription.vue?vue&type=script&lang=js&"
import style0 from "./NewPrescription.vue?vue&type=style&index=0&id=c86b3ae6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c86b3ae6",
  null
  
)

export default component.exports